import React, { useEffect } from "react";
import { ApiCommon } from "src/api/api_common";

/** Data provided by the {@link ChangelogProvider} */
export type ChangelogContext = {
    /** Changelog */
    changelog: string;
    /** Current version which is returned by the API */
    current_version: string;
    /** Whether the current version is running in production mode*/
    isProd: boolean;
};

/** {@link React.Context} for the {@link ChangelogContext} */
const CHANGELOG_CONTEXT = React.createContext<ChangelogContext>({
    changelog: "",
    current_version: "",
    isProd: false,
});
CHANGELOG_CONTEXT.displayName = "ChangelogContext";
export default CHANGELOG_CONTEXT;

/** Props for the {@link ChangelogProvider} */
export type ChangelogProviderProps = {
    /** Children of the provider */
    children: React.ReactNode;
};

/**
 * Provider for the {@link ChangelogContext}
 */
export function ChangelogProvider(props: ChangelogProviderProps) {
    const [changelog, setChangelog] = React.useState<string | "loading">("loading");
    const [currentVersion, setCurrentVersion] = React.useState<string | "loading">("loading");
    const [isProd, setIsProd] = React.useState(false);
    let fetching = false;

    const fetchVersion = async () => {
        if (fetching) return;
        fetching = true;

        const res = await ApiCommon.version.get();
        setCurrentVersion(res.version);
        setIsProd(res.is_prod);

        fetching = false;
    };

    useEffect(() => {
        fetchVersion().then();
        fetch("/CHANGELOG.md")
            .then((response) => response.text())
            .then((text) => setChangelog(text));
    }, []);

    if (currentVersion === "loading" && changelog === "loading") {
        return <div>Loading ..</div>;
    }

    return (
        <CHANGELOG_CONTEXT.Provider
            value={{
                changelog: changelog,
                current_version: currentVersion,
                isProd,
            }}
        >
            {props.children}
        </CHANGELOG_CONTEXT.Provider>
    );
}
